const extend = Object.assign;

/**
 * `code` is the language code from the browser.
 *
 * `expected` is similar or identical with ISO code.
 *
 * @type {{code: string, expected: string}[]}
 */
const googleChromeAvailableLanguages = [
    {expected: "af-ZA", code: "af"},
    {expected: "am-ET", code: "am"},
    {expected: "es-ES", code: "an"},
    {expected: "en-AE", code: "ar"},
    {expected: "es-ES", code: "ast"},
    {expected: "az-AZ", code: "az"},
    {expected: "ru-BY", code: "be"},
    {expected: "bg-BG", code: "bg"},
    {expected: "bn-BD", code: "bn"},
    {expected: "fr-FR", code: "br"},
    {expected: "bs-BA", code: "bs"},
    {expected: "es-ES", code: "ca"},
    {expected: "en-PH", code: "ceb"},
    {expected: "en-IQ", code: "ckb"},
    {expected: "fr-FR", code: "co"},
    {expected: "cs-CZ", code: "cs"},
    {expected: "cy-CY", code: "cy"},
    {expected: "da-DK", code: "da"},
    {expected: "de-AT", code: "de-AT"},
    {expected: "de-CH", code: "de-CH"},
    {expected: "de-DE", code: "de-DE"},
    {expected: "de-LI", code: "de-LI"},
    {expected: "de-DE", code: "de"},
    {expected: "el-GR", code: "el"},
    {expected: "en-AU", code: "en-AU"},
    {expected: "en-CA", code: "en-CA"},
    {expected: "en-GB", code: "en-GB"},
    {expected: "en-IN", code: "en-IN"},
    {expected: "en-NZ", code: "en-NZ"},
    {expected: "en-US", code: "en-US"},
    {expected: "en-ZA", code: "en-ZA"},
    {expected: "en-US", code: "en"},
    {expected: "eo-EO", code: "eo"},
    {expected: "es-AR", code: "es-AR"},
    {expected: "es-CL", code: "es-CL"},
    {expected: "es-CO", code: "es-CO"},
    {expected: "es-ES", code: "es-CR"},
    {expected: "es-ES", code: "es-ES"},
    {expected: "es-HN", code: "es-HN"},
    {expected: "es-MX", code: "es-MX"},
    {expected: "es-PE", code: "es-PE"},
    {expected: "es-US", code: "es-US"},
    {expected: "es-UY", code: "es-UY"},
    {expected: "es-VE", code: "es-VE"},
    {expected: "es-ES", code: "es"},
    {expected: "et-EE", code: "et"},
    {expected: "es-ES", code: "eu"},
    {expected: "fa-IR", code: "fa"},
    {expected: "fi-FI", code: "fi"},
    {expected: "en-PH", code: "fil"},
    {expected: "fo-FO", code: "fo"},
    {expected: "fr-CA", code: "fr-CA"},
    {expected: "fr-CH", code: "fr-CH"},
    {expected: "fr-FR", code: "fr-FR"},
    {expected: "fr-FR", code: "fr"},
    {expected: "nl-NL", code: "fy"},
    {expected: "ga-IE", code: "ga"},
    {expected: "en-GB", code: "gd"},
    {expected: "es-ES", code: "gl"},
    {expected: "es-PY", code: "gn"},
    {expected: "hi-IN", code: "gu"},
    {expected: "en-NG", code: "ha"},
    {expected: "en-US", code: "haw"},
    {expected: "he-IL", code: "he"},
    {expected: "hi-IN", code: "hi"},
    {expected: "zh-CN", code: "hmn"},
    {expected: "hr-HR", code: "hr"},
    {expected: "fr-HT", code: "ht"},
    {expected: "hu-HU", code: "hu-HU"},
    {expected: "hu-HU", code: "hu"},
    {expected: "ru-AM", code: "hy"},
    {expected: "en-US", code: "ia"},
    {expected: "id-ID", code: "id"},
    {expected: "en-NG", code: "ig"},
    {expected: "is-IS", code: "is"},
    {expected: "it-CH", code: "it-CH"},
    {expected: "it-IT", code: "it-IT"},
    {expected: "it-IT", code: "it"},
    {expected: "ja-JP", code: "ja"},
    {expected: "en-ID", code: "jv"},
    {expected: "en-GE", code: "ka"},
    {expected: "ru-KZ", code: "kk"},
    {expected: "km-KH", code: "km"},
    {expected: "hi-IN", code: "kn"},
    {expected: "ko-KR", code: "ko"},
    {expected: "en-IQ", code: "ku"},
    {expected: "ru-KG", code: "ky"},
    {expected: "en-US", code: "la"},
    {expected: "fr-LU", code: "lb"},
    {expected: "fr-CD", code: "ln"},
    {expected: "en-LA", code: "lo"},
    {expected: "lt-LT", code: "lt"},
    {expected: "lv-LV", code: "lv"},
    {expected: "fr-MG", code: "mg"},
    {expected: "en-NZ", code: "mi"},
    {expected: "mk-MK", code: "mk"},
    {expected: "en-IN", code: "ml"},
    {expected: "mn-MN", code: "mn"},
    {expected: "ro-MD", code: "mo"},
    {expected: "en-IN", code: "mr"},
    {expected: "ms-MY", code: "ms"},
    {expected: "mt-MT", code: "mt"},
    {expected: "en-MM", code: "my"},
    {expected: "no-NO", code: "nb"},
    {expected: "ne-NP", code: "ne"},
    {expected: "nl-NL", code: "nl"},
    {expected: "no-NO", code: "nn"},
    {expected: "no-NO", code: "no"},
    {expected: "ny-MW", code: "ny"},
    {expected: "fr-FR", code: "oc"},
    {expected: "en-ET", code: "om"},
    {expected: "en-IN", code: "or"},
    {expected: "en-PK", code: "pa"},
    {expected: "pl-PL", code: "pl"},
    {expected: "en-AF", code: "ps"},
    {expected: "pt-BR", code: "pt-BR"},
    {expected: "pt-PT", code: "pt-PT"},
    {expected: "pt-PT", code: "pt"},
    {expected: "es-PE", code: "qu"},
    {expected: "de-CH", code: "rm"},
    {expected: "ro-RO", code: "ro"},
    {expected: "ru-RU", code: "ru"},
    {expected: "en-IN", code: "sd"},
    {expected: "hr-HR", code: "sh"},
    {expected: "si-LK", code: "si"},
    {expected: "sk-SK", code: "sk"},
    {expected: "sl-SI", code: "sl"},
    {expected: "sm-WS", code: "sm"},
    {expected: "sn-ZW", code: "sn"},
    {expected: "so-SO", code: "so"},
    {expected: "en-AL", code: "sq"},
    {expected: "sr-RS", code: "sr"},
    {expected: "en-LS", code: "st"},
    {expected: "en-SD", code: "su"},
    {expected: "en-SE", code: "sv"},
    {expected: "sw-KE", code: "sw"},
    {expected: "en-LK", code: "ta"},
    {expected: "en-IN", code: "te"},
    {expected: "ru-TJ", code: "tg"},
    {expected: "th-TH", code: "th"},
    {expected: "ti-ER", code: "ti"},
    {expected: "ru-TM", code: "tk"},
    {expected: "to-TO", code: "to"},
    {expected: "tr-TR", code: "tr"},
    {expected: "ru-RU", code: "tt"},
    {expected: "en-GH", code: "tw"},
    {expected: "zh-CN", code: "ug"},
    {expected: "uk-UA", code: "uk"},
    {expected: "en-PK", code: "ur"},
    {expected: "ru-UZ", code: "uz"},
    {expected: "vi-VN", code: "vi"},
    {expected: "fr-FR", code: "wa"},
    {expected: "en-ZA", code: "xh"},
    {expected: "en-IL", code: "yi"},
    {expected: "en-NG", code: "yo"},
    {expected: "zh-CN", code: "zh-CN"},
    {expected: "zh-HK", code: "zh-HK"},
    {expected: "zh-TW", code: "zh-TW"},
    {expected: "zh-CN", code: "zh"},
    {expected: "en-ZA", code: "zu"},
];

/**
 * [http://www.lingoes.net/en/translator/langcode.htm]()
 *
 * 1. Set expected value - this is similar or identical with the ISO code of the given language.
 * 2. Set code value - this value is coming from the browsers language (`navigator.language`).
 *
 * Example:
 * Browser's language is **catalan** and `navigator.language` returns with **ca**. It is not enough, we want to use
 * `es-ES` instead of `ca-ES`.
 *
 * @param {string} language
 * @return {string[]|string}
 */
const _getChromeLanguageItem = (language= "en") => {
    try {
        const item = (googleChromeAvailableLanguages.find(({code}) => {
            return code.toLowerCase() === language.toLowerCase();
        }) || {expected: "en-US"}).expected.split("-");

        return item;
    } catch (error) {
        captureException(extend(error, language));

        return ["en", "US"];
    }
};

/**
 *
 * @param {string} language
 * @return {string|string[]}
 */
export const getBrowserCountry = (language = navigator.language) => {
    try {
        return _getChromeLanguageItem(language)[1];
    } catch (error) {
        captureException(extend(language, error));

        return "US";
    }
};

/**
 *
 * @param {string|undefined} language
 * @return {string|string[]}
 */
export const getBrowserLanguage = (language = navigator.language) => {
    try {
        return _getChromeLanguageItem(language)[0];
    } catch (error) {
        captureException(extend(language, error));

        return "en";
    }
};
